// Prevent service worker will embedded whole config into the worker bundle
export const serviceWorker = {
  cacheVersion: process.env.NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION ?? "",
  measurementApiKey: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_API_KEY ?? "",
  measurementId: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID ?? "",
  notificationGaProfileId: process.env.NEXT_PUBLIC_GA_PUSH_NOTIFICATION_PROFILE_ID ?? "",
};
